import React from 'react';
import { focusInput } from './focus-input.js';
import { Item } from './item.js';
import { setValue } from './set-value.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Options = /* @__PURE__ */ __name(({
  activeIndex,
  getItemProps,
  indexOffset = 0,
  listRef,
  options,
  refs,
  setOpen,
  value
}) => {
  if (options.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, options.map((item, index) => /* @__PURE__ */ React.createElement(Item, {
    ...getItemProps({
      key: item,
      ref(node) {
        listRef.current[index + indexOffset] = node;
      },
      onClick: () => {
        if (refs.reference.current) {
          setValue(refs.reference.current, item);
          setOpen(false);
          focusInput(refs.reference.current);
        }
      }
    }),
    active: activeIndex === index + indexOffset,
    value
  }, item)));
}, "Options");

export { Options };
//# sourceMappingURL=options.js.map
